export enum LoginSource {
  LOGIN,
  INDICATION,
  QUOTE_SETUP_PRESET,
}

export enum LoginView {
  LOGIN,
  SIGNUP,
}

export enum RegistrationRole {
  POLICYHOLDER = 'POLICYHOLDER',
  BILLING_CONTACT = 'BILLING_CONTACT',
  BROKER_PRODUCER = 'BROKER_PRODUCER',
}

/** Pre-filled sign-up from an email's register link: /sign-up?brokerageCode=XXXX-XXXX&email=... */
export type RegistrationPrefill = { brokerageCode: string; email?: string; firstName?: string; lastName?: string };

/** The register link's query parameters; sign-up removes them from the address bar once read. */
export const REGISTRATION_LINK_PARAMS = ['brokerageCode', 'email', 'firstName', 'lastName', 'redirect'] as const;

export const getRegistrationPrefill = (searchParams: URLSearchParams): RegistrationPrefill | undefined => {
  const brokerageCode = searchParams.get('brokerageCode')?.trim();
  if (!brokerageCode) return undefined;
  return {
    brokerageCode,
    email: searchParams.get('email')?.trim() || undefined,
    firstName: searchParams.get('firstName')?.trim() || undefined,
    lastName: searchParams.get('lastName')?.trim() || undefined,
  };
};
